import { Link, LinkProps } from "react-router-dom";
import { useScrollNavigation } from "@/hooks/use-scroll";

export function ScrollLink({ to, children, ...props }: LinkProps) {
  const { navigateAndScroll } = useScrollNavigation();

  return (
    <Link
      to={to}
      onClick={(e) => {
        e.preventDefault();
        navigateAndScroll(typeof to === 'string' ? to : to.pathname || '/');
      }}
      {...props}
    >
      {children}
    </Link>
  );
} 